import { MODAL_OPEN } from 'modal/store/actionTypes';
import * as actionTypes from './actionTypes';

const initialState = {
  // Indicates if the user is offline
  isOffline: false,
  // Documents that are currently being cached for offline use
  currentlyCachingDocuments: [],
  // Document ids being cached where the download failed due to an incorrect password
  currentlyCachingDocumentIdsWithIncorrectPassword: [],
  // All document ids available for offline use
  ids: [],
  // All document ids that have been edited while offline
  // and need to be synchronized with the server when back online
  waitingForSyncIds: [],
  isSyncing: false,
  // All document ids that have not been synced correctly
  syncErrorIds: [],
  // All document ids that are not stored correctly anymore
  storageErrorIds: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_IS_OFFLINE:
      return {
        ...state,
        isOffline: action.isOffline,
      };
    case actionTypes.CACHE_DOCUMENT:
      return {
        ...state,
        currentlyCachingDocuments: [
          ...state.currentlyCachingDocuments,
          ...(state.currentlyCachingDocuments.some((d) => d.id === action.document.id)
            ? [] : [action.document]),
        ],
      };
    case actionTypes.CACHE_DOCUMENT_SUCCESS:
      return {
        ...state,
        ids: [
          ...state.ids,
          ...(state.ids.some((id) => id === action.document.id) ? [] : [action.document.id]),
        ],
        currentlyCachingDocuments: state.currentlyCachingDocuments.filter((document) =>
          document.id !== action.document.id),
        currentlyCachingDocumentIdsWithIncorrectPassword:
            state.currentlyCachingDocumentIdsWithIncorrectPassword
              .filter((document) => document.id !== action.document.id),
      };
    case actionTypes.CACHE_DOCUMENT_PASSWORD_INCORRECT:
      return {
        ...state,
        currentlyCachingDocumentIdsWithIncorrectPassword: [
          ...state.currentlyCachingDocumentIdsWithIncorrectPassword,
          action.document.id,
        ],
      };
    case actionTypes.CACHE_DOCUMENTS:
      return {
        ...state,
        currentlyCachingDocuments: [
          ...state.currentlyCachingDocuments,
          ...action.documents,
        ],
        currentlyCachingDocumentIdsWithIncorrectPassword: [],
      };
    case actionTypes.CACHE_DOCUMENTS_SUCCESS:
      return {
        ...state,
      };
    case actionTypes.CACHE_DOCUMENTS_ABORT:
      return {
        ...state,
        currentlyCachingDocuments: [],
        currentlyCachingDocumentIdsWithIncorrectPassword: [],
      };
    case MODAL_OPEN:
      // clear caching state when caching modal is opened
      // This is a sanity check in case there is some uncaught error and
      // incorrect state is persisted in the offline store
      // TODO: we should exclude this UI state from being stored offline instead
      return action.name === 'DOCUMENT_CACHE_OFFLINE'
        ? {
          ...state,
          currentlyCachingDocuments: [],
          currentlyCachingDocumentIdsWithIncorrectPassword: [],
        }
        : state;
    case actionTypes.UNCACHE_DOCUMENT:
      return {
        ...state,
        ids: state.ids.filter((id) => id !== action.document.id),
        waitingForSyncIds: state.waitingForSyncIds.filter((id) => id !== action.document.id),
        syncErrorIds: state.syncErrorIds.filter((id) => id !== action.document.id),
        storageErrorIds: state.storageErrorIds.filter((id) => id !== action.document.id),
      };
    case actionTypes.ADD_WAITING_FOR_SYNC_ID:
      return {
        ...state,
        waitingForSyncIds: state.waitingForSyncIds.includes(action.id)
          ? state.waitingForSyncIds
          : [...state.waitingForSyncIds, action.id],
      };
    case actionTypes.REMOVE_WAITING_FOR_SYNC_ID:
      return {
        ...state,
        waitingForSyncIds:
            state.waitingForSyncIds.filter((id) => id !== action.id),
      };
    case actionTypes.ADD_SYNC_ERROR_ID:
      return {
        ...state,
        syncErrorIds: state.syncErrorIds.includes(action.id)
          ? state.syncErrorIds
          : [...state.syncErrorIds, action.id],
        waitingForSyncIds:
            state.waitingForSyncIds.filter((id) => id !== action.id),
      };
    case actionTypes.ADD_STORAGE_ERROR_ID:
      return {
        ...state,
        storageErrorIds: state.storageErrorIds.includes(action.id)
          ? state.storageErrorIds
          : [...state.storageErrorIds, action.id],
        waitingForSyncIds:
            state.waitingForSyncIds.filter((id) => id !== action.id),
      };
    case actionTypes.REMOVE_SYNC_ERROR_ID:
      return {
        ...state,
        syncErrorIds:
            state.syncErrorIds.filter((id) => id !== action.id),
      };
    case actionTypes.SYNC_OFFLINE_CHANGES:
      return {
        ...state,
        isSyncing: true,
      };
    case actionTypes.SYNC_OFFLINE_CHANGES_SUCCESS:
      return {
        ...state,
        isSyncing: false,
      };
    default:
      return state;
  }
};
